var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__(
          "activities.listing.massActions.ActivitiesListingMassDelete.delete_activities_title"
        ),
        primaryAction: {
          type: "primary-destructive",
          label: _vm.$t.__("common.actions.confirm_and_delete"),
          action: function() {
            return _vm.confirmMassDelete()
          },
          loading: _vm.isSubmitting
        },
        secondaryActions: [
          {
            label: _vm.$t.__("common.actions.cancel"),
            action: function() {
              _vm.$emit("close")
            }
          }
        ]
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("span", { staticClass: "typographies-paragraph-medium-regular" }, [
          _vm._v("\n            " + _vm._s(_vm.textContent) + "\n        ")
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }